import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/routes/_user/profile";

export const Route = createFileRoute("/admin/profile")({ component: ProfilePage });
